import React from 'react'
import autosize from 'autosize'
import Tooltip from 'components/Tooltip/Tooltip'

class TextArea extends React.Component {
    static getDerivedStateFromProps(props, state) {
        if (state.prevPropValue !== props.value) {
            return {
                prevPropValue: props.value,
                value: props.value || '',
            }
        }
        return {}
    }

    constructor(props) {
        super(props)
        this.state = {
            value: this.props.value,
            prevPropValue: this.props.value,
        }

        this.textArea = React.createRef()
    }

    componentDidMount() {
        const textAreaRef = this.textArea.current
        if (textAreaRef) {
            autosize(textAreaRef)
        }
    }

    onChange = evt => {
        const { onUpdate, id, name, payload } = this.props

        this.setState({ value: evt.target.value })
        onUpdate(id, { [name]: evt.target.value }, payload)
    }

    render() {
        const {
            tooltipText,
            schema: { label = '', maxLength = null },
        } = this.props
        const { value } = this.state
        const textAreaProps = {
            ref: this.textArea,
            rows: 5,
            value,
            onChange: this.onChange,
        }
        if (maxLength) textAreaProps.maxLength = maxLength

        return (
            <div className="control-box">
                <p className="label">
                    {label}
                    {<Tooltip tooltipText={tooltipText} />}
                </p>
                <div className="content textarea">
                    <textarea {...textAreaProps} />
                </div>
            </div>
        )
    }
}

export default TextArea
